import "./App.css"
import { Route, Routes, Navigate } from "react-router-dom"

import { Layout } from "./components/Layout"
import * as routes from "./routes"
import { useState, useEffect } from "react"

const AUTHENTICATED_KEY = "authenticated"

function App() {
  // Initialiser depuis localStorage
  const [authenticated, setAuthenticatedState] = useState(() => {
    try {
      const stored = window.localStorage.getItem(AUTHENTICATED_KEY)
      return stored === "true"
    } catch {
      return false
    }
  })

  // Sauvegarder dans localStorage quand authenticated change
  useEffect(() => {
    try {
      if (authenticated) {
        window.localStorage.setItem(AUTHENTICATED_KEY, "true")
      } else {
        window.localStorage.removeItem(AUTHENTICATED_KEY)
      }
    } catch {
      // localStorage non disponible (mode privé, etc.)
    }
  }, [authenticated])

  // Wrapper pour setAuthenticated qui met à jour aussi le state
  const setAuthenticated = (value) => {
    setAuthenticatedState(value)
  }

  return !authenticated ? (
    <Layout>
      <Routes>
        <Route
          path="*"
          element={<routes.Login setAuthenticated={setAuthenticated} />}
        />
        {/* <Route exact path="/confirm" element={<routes.Confirm />} /> */}
      </Routes>
    </Layout>
  ) : (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/film" replace />} />
        <Route exact path="/home" element={<routes.Home />} />

        <Route exact path="/adresses" element={<routes.Adresses />} />
        <Route exact path="/infos" element={<routes.Infos />} />
        <Route exact path="/jukebox" element={<routes.Jukebox />} />
        <Route exact path="/film" element={<routes.Movie />} />
        <Route path="*" element={<routes.NotFound />} />
      </Routes>
    </Layout>
  )
}

export default App
